/**
 * Depending on presence of config, returns item.badges,
 * or a mix of badges and a aditional provided label
 * @param {Object} item 
 * @param {boolean} showStatusAsBadge 
 * @param {boolean} isInReturnItems 
 * @param {string} label 
 */
export const processBadges = ({ badges = [] }: any, showStatusAsBadge: boolean, isInReturnItems: boolean, label: string) =>
    (showStatusAsBadge && isInReturnItems && [...badges, { type: 'info', label }]) ||
    badges;
